



























































































































































































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default Vue.extend({
  name: "ProductList",
  data() {
    return {
      active: "",
      searchDebounce: null,
      search: "",
      selected: [],
      file: null,
      fileSubPro: null,
      page: 1,
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      total: 0,
      defaultOpenedDetails: [1],
      upLoading: false,
      subProduct: [],
      key: 1
    };
  },
  methods: {
    ...mapMutations({
      openModalAdd: "product/openModalAdd",
      openModalEdit: "product/openModalEdit"
    }),
    ...mapActions({
      fechListProduct: "product/fechListProduct",
      deleteProduct: "product/deleteProduct",
      deleteListProduct: "product/deleteListProduct",
      pageChange: "product/pageChange",
      perPageChange: "product/perPageChange",
      searchProduct: "product/searchProduct",
      upLoadCSV: "product/upLoadCSV",
      getCSVTemplate: "product/getCSVTemplate",
      showModalAct: "productCategory/showModalAct",
      getAllCategory: "productCategory/getAllCategory",
      getCSVProduct: "product/getAllCSV",
      filterQR: "product/filter",
      updateProduct: "product/updateProduct",
      exportSubProduct: "product/exportSubProduct",
      importCSVSubProcudt: "product/importCSVSubProcudt",
      getSubProduct: "product/getSubProduct"
    }),
    handleListQr(id: string) {
      let routeData = this.$router.resolve({
        name: "productQr",
        params: { id: id }
      });
      window.open(routeData.href, "_blank");
    },
    async detailsOpen(row: any) {
      if (row.requireQR) {
        const res = await this.getSubProduct(row.code);
        this.subProduct[row._id] = res;
        this.key = this.key++;
      }
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
    handleOpenModalAdd() {
      this.getAllCategory();
      this.openModalAdd();
    },
    handleOpenModalEdit(id) {
      this.getAllCategory();
      this.openModalEdit(id);
    },
    removeSelected() {
      const selectedId = this.selected.map(item => item._id);
      this.deleteListProduct(selectedId);
    },
    searchChanged() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.searchProduct(this.search);
      }, 500);
    },

    onPageChange(page) {
      this.pageChange(page);
    },
    perPageChanged() {
      this.perPageChange(this.perPage);
    },
    async upload() {
      this.upLoading = true;
      try {
        await this.upLoadCSV(this.file);
        this.upLoading = false;
      } catch (error) {
        console.log(error);
        this.upLoading = false;
      }
    },
    async uploadSubPro() {
      this.upLoading = true;
      try {
        await this.importCSVSubProcudt(this.fileSubPro);
        this.upLoading = false;
      } catch (error) {
        console.log(error);
        this.upLoading = false;
      }
    },
    filterChanged(value: string) {
      if (value == "ALL") {
        this.filterQR({ requireQR: undefined });
      }
      if (value == "NA") {
        this.filterQR({ requireQR: false });
      }
      if (value == "QR") {
        this.filterQR({ requireQR: true });
      }
    },
    onToggleStatus(product) {
      let allowSale = !product.allowSale
      this.updateProduct({ id: product._id, product: { allowSale } })
    },
  },
  computed: {
    ...mapGetters({
      products: "product/getProducts",
      loadingProducts: "product/loadingProducts",
      count: "product/count"
      // upLoading: "product/upLoading"
    })
  },
  created() {
    this.fechListProduct();
  },
});
